import { Outlet } from 'react-router-dom'
import { Header } from '@/components/common/Header'
import { Footer } from '@/components/common/Footer'
import { ScrollToTop } from '@/components/common/ScrollToTop'
import { ScrollToTopNextRoute } from '../common/ScrollToTopNextRoute'

export function MainLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <ScrollToTopNextRoute/>
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  )
}

